import React from 'react';
import { observer } from 'mobx-react-lite';
import { useSearchParamsUtils } from 'app/hooks/useSearchParamsUtils';
import SearchPage from 'pages/searchPage/searchPage';

export default observer(function SearchFallback({
  children,
}: {
  children: React.ReactNode;
}) {
  const { search } = useSearchParamsUtils();

  return <>{search === null ? children : <SearchPage></SearchPage>}</>;
});
